//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setStorage, getStorage, storageKey } from '@/utils/storage'
export default {

	data () {
		return {
			industry: [
		      {
		        name: '便利超市', id: '101'
		      },
		      {
		        name: '餐饮行业', id: '102'
		      },
		      {
		        name: '烘焙行业', id: '107'
		      },
		      {
		        name: '母婴行业', id: '105'
		      },
		      {
		        name: '宠物行业', id: '106'
		      },
		      { 
		        name: '美业休闲', id: '108'
		      }
		    ],
		}
	},

	computed: {
		user() {
			return this.$store.state.user;
		},
	},

	methods: {
		handleChckerClick(id) {
			setStorage('industry_id', id);
			this.$router.push('/problem');
		}	
	},

	created () {
		let industry = getStorage(storageKey.industry);
		if (industry !== null) {
			let filter = this.industry.filter((item, index) => {
				return item.name === industry;
			})
			if (filter.length !== 0) {
				this.handleChckerClick(filter[0].id)
			}
		}
	},

	mounted () {
		
	},
}



// WEBPACK FOOTER //
// ./src/views/industry/industry.vue